import { api } from '@sentinel/web-core';
import type { Specialty, SpecialtyEntity, SpecialtyUpdate } from '@sentinel/shared';

const PLURAL = { team: 'teams', resource: 'resources', device: 'devices' } as const;

/** The specialty a team, resource or device is drawn with (marker V4, DS §09). */
export const markerEndpoints = {
  setSpecialty: (missionId: string, entity: SpecialtyEntity, id: string, body: SpecialtyUpdate) =>
    api<{ id: string; specialty: Specialty | null }>(
      `/missions/${missionId}/${PLURAL[entity]}/${id}/specialty`,
      { method: 'PATCH', body },
    ),
};
